import { BreadcrumbData } from '~/features/shared/breadcrumbList/types'

type GetBreadcrumb = (conditions: {
  shopType?: 'all' | 'apparel' | 'salon'
  brandName?: string
  searchWord?: string
}) => BreadcrumbData[]

export const getBreadcrumb: GetBreadcrumb = ({
  shopType = 'all',
  brandName,
  searchWord,
}) => {
  const title =
    shopType === 'salon'
      ? '美容室一覧'
      : shopType === 'apparel'
        ? 'アパレルショップ一覧'
        : `店舗一覧`
  const subTitle = [
    brandName ? `取り扱いブランド：${brandName}` : undefined,
    searchWord ? `キーワード：${searchWord}` : undefined,
  ]
    .filter(Boolean)
    .join(',')
  return [{ name: `${title}${subTitle ? `（${subTitle}）` : ''}` }]
}
